import React from "react";
import BlogPost from "../components/postPage/BlogPost";
import Breadcrumb from "../components/postPage/Breadcrumb";
import PostContainer from "../components/postPage/PostContainer";
import RelatedPosts from "../components/postPage/RelatedPosts";

export default function Post() {
  return (
    <>
      <Breadcrumb />
      <PostContainer>
        <BlogPost />
        <RelatedPosts />
      </PostContainer>
    </>
  );
}
